/**
 * Generated runtime TestId mirror for frontend/src/pages/AccessRequests.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessRequestsTestIds = {
  accessRequestsList: "access-requests-list",
  btnCreateRequest: "btn-create-request",
  colBeneficiary: "col-beneficiary",
  colCreatedAt: "col-created-at",
  colItems: "col-items",
  colJustification: "col-justification",
  colRequester: "col-requester",
  colStatus: "col-status",
  linkRequestDetail: (request_id: string) => `link-request-detail-${request_id}`,
  linkRequestDetailPrefix: () => "link-request-detail-" as TestIdPrefix,
  requestItems: (request_id: string) => `request-items-${request_id}`,
  requestItemsPrefix: () => "request-items-" as TestIdPrefix
} as const;
